import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f444525"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "headerBarWrapper" }
const _hoisted_2 = { id: "headerBar" }
const _hoisted_3 = { class: "group" }
const _hoisted_4 = {
  key: 0,
  class: "triggerHelp placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "mobileWrapperGroup"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "group" }

import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { useRoute, useRouter } from '@/composables/router/VueRouter';
import BrowserDetection from '@/data/BrowserDetection';
import { Track, TrackType } from '@/data/datatypes/Track';
import NonAppMenu from '@/NonAppMenu.vue';
import PrimaryMenu from '@/PrimaryMenu.vue';
import RouteNames from '@/router/RouteNames';
import { useTrackEntriesStore } from '@/stores/TrackEntries';
import { useTracksStore } from '@/stores/Tracks';
import { useUIStateStore } from '@/stores/UIState';

interface Emits {
  (e: 'clearAllNotifications'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  emits: ["clearAllNotifications"],
  setup(__props) {

const tracksStore = useTracksStore();
const trackEntriesStore = useTrackEntriesStore();
const uiStateStore = useUIStateStore();

const route = useRoute();
const router = useRouter();



const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

const showReturnToWorkspaceOverview: ComputedRef<boolean> = computed(() => {
  if (!isMobile.value) {
    return false;
  }
  if (route.name === RouteNames.TRACK_DASHBOARD_ROUTE_NAME) {
    return false;
  }
  if (!activeTrack.value) {
    return false;
  }
  // Check that we're in a child of the main track route
  let childRoute: boolean = false;
  for (const routeRecord of route.matched ?? []) {
    if (routeRecord.name === RouteNames.TRACK_MAIN_BASE_ROUTE_NAME) {
      childRoute = true;
    }
  }
  if (childRoute) {
    if (![TrackType.STANDARD, TrackType.BREAKOUT, TrackType.CHANNEL_CHAT].includes(activeTrack.value.type)) {
      childRoute = false;
    }
  }

  return childRoute;
});

function handleMobileHeaderClick(): void {
  const validTrackTypes = [TrackType.STANDARD, TrackType.BREAKOUT];
  if (activeTrack.value && validTrackTypes.includes(activeTrack.value.type)) {
    uiStateStore.setAdditionalContentVisible(!uiStateStore.showAdditionalContent);
  }
}

function returnToWorkspaceOverview(): void {
  if (trackEntriesStore.currentlyDisplayedFile) {
    trackEntriesStore.setCurrentlyDisplayedFile(null);
  }
  if (activeTrack.value) {
    router.push({
      name: RouteNames.TRACK_DASHBOARD_ROUTE_NAME,
      params: { trackId: activeTrack.value.id }
    });
  }
}

const activeTrack: ComputedRef<Track | undefined> = computed(() => {
  return tracksStore.activeTrack;
});

const mobileHeader: ComputedRef<string> = computed(() => {
  return activeTrack.value?.title ?? '';
});

const mobileHeaderToggleLabel: ComputedRef<string> = computed(() => {
  return `${uiStateStore.showAdditionalContent ? 'Hide' : 'Show'} details`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PrimaryMenu, {
          onClearAllNotifications: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearAllNotifications')))
        }),
        (isMobile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      (isMobile.value && activeTrack.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (isMobile.value && showReturnToWorkspaceOverview.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: returnToWorkspaceOverview,
                  class: "back"
                }, [
                  _createVNode(BrandIcon, {
                    name: "special/chevron-left",
                    title: "back"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: handleMobileHeaderClick,
              class: "title"
            }, [
              _createElementVNode("div", {
                class: "mobileHeader",
                textContent: _toDisplayString(mobileHeader.value)
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "toggle",
                textContent: _toDisplayString(mobileHeaderToggleLabel.value)
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(NonAppMenu, {
          onClearAllNotifications: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clearAllNotifications')))
        })
      ])
    ])
  ]))
}
}

})